import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class EstheService {

    public static async fetchMusicGenres() {
        return httpResource.get('/v2/esthe/music/genres');
    }
}